export const toShowProTag = (isProUser: boolean, proFlagOfProduct: number): boolean => {
  if (
    isProUser
    && (
      (proFlagOfProduct === 1)
      || (proFlagOfProduct === 2)
    )
  ) {
    return true;
  }

  return false;
};
